module.exports = __webpack_public_path__ + "img/mobile3m2900_voucher_m.10d331b3.jpg";